<template>
    <MainContainer>
        <template #sidebar></template>
        <h2 class="mb-4">Mitgliedsbeiträge</h2>
        <b-row>
            <b-col cols="4">
<!--                <b-button-->
<!--                    variant="primary"-->
<!--                    block-->
<!--                    :to="{ path: '/fibu/mitgliedsbeitraege/verwalten' }"-->
<!--                >-->
<!--                    Mitgliedsbeiträge verwalten-->
<!--                </b-button>-->
                <b-button
                    variant="primary"
                    block
                    :to="{ path: `/fibu/mitgliedsbeitraege/erstellen` }"
                >
                    Beitragsforderungen erstellen
                </b-button>
                <b-button
                    variant="primary"
                    block
                    :to="{ path: '/fibu/mitgliedsbeitraege/drucken' }"
                >
                    Beitragsrechnungen einsehen / drucken
                </b-button>
            </b-col>
        </b-row>
    </MainContainer>
</template>
<script>
import MainContainer from "@/components/MainContainer/MainContainer";

export default {
    name: "Mitgliedsbeitraege",
    components: {
        MainContainer
    }
}
</script>

<style scoped>

</style>